import { forwardRef } from "react";
import {observer} from "mobx-react";

import classNames from "classnames";
import styles from "./styles/SidebarContainer.module.scss";

import {Transition} from 'react-transition-group';
import SafeRouter from "../../utilities/SafeRouter";
import FontAwesome from "../../utilities/FontAwesome";

const defaultStyle = {
    transition: `transform 250ms ease`,
    transform: 'translateX(-100%)',
};

const transitionStyles = {
    entering: {transform: 'translateX(0)'},
    entered: {transform: 'translateX(0)'},
    exiting: {transform: 'translateX(-100%)'},
    exited: {transform: 'translateX(-100%)'},
};

const SidebarContainer = observer(forwardRef((props, ref) => {
    const containerClassName = classNames({
        [styles.container]: true,
        [props.className]: props.className,
    });

    return (
        <Transition in={props.in} timeout={500} mountOnEnter>
            {(state) => {
                return <section id={"sb-admin-side-panel"} ref={ref} className={containerClassName} style={{...defaultStyle, ...transitionStyles[state]}}>
                    <button className={styles.topExitButton} onClick={() => SafeRouter.setQueries(["spview", null], ["type", null], ["id", null])}>
                        <FontAwesome prefix={'fas'} name={'fa-times'}/>
                    </button>
                    {props.children}
                </section>
            }}
        </Transition>
    );
}));

export default SidebarContainer;
